import { Link } from "react-router-dom";
import usePageMeta from "@/hooks/usePageMeta";

export default function NotFound() {
  usePageMeta("页面不存在 - 51每日大赛", "您访问的页面不存在，请返回首页浏览每日赛事资讯、赛程安排与最新比赛结果。");

  return (
    <div className="w-full px-4 md:px-8 py-24 text-center flex flex-col items-center">
      <div className="font-heading text-7xl md:text-9xl text-primary-500">404</div>
      <h1 className="mt-4 font-heading text-xl md:text-2xl text-foreground-950">抱歉，页面走丢了</h1>
      <p className="mt-2 text-sm text-foreground-600">您访问的页面不存在或已被移除。</p>
      <div className="mt-8 flex flex-col sm:flex-row gap-3">
        <Link
          to="/"
          className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          <i className="ri-home-4-line" /> 返回首页
        </Link>
        <Link
          to="/events"
          className="inline-flex items-center justify-center gap-2 h-11 px-6 rounded-md border border-background-300 text-foreground-800 text-sm font-medium hover:border-primary-300 hover:text-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          浏览赛事
        </Link>
      </div>
    </div>
  );
}